import AWS from 'aws-sdk';
import shortuuid from 'short-uuid'

var bucketName = "mkt-screenrecording-videos.wideo.co";
var bucketRegion = "us-east-1";
var IdentityPoolId = "us-east-1:c2d458c5-3fa9-4b48-9ccf-5f431c99a610";

AWS.config.update({
    region: bucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: IdentityPoolId
    })
});

const blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return theBlob as File;
}
/**
 * Upload a blob video to s3. 
 * @param blobFile 
 * @returns an ID
 * 
 * To watch the video use: d1y5xfvzlo94cr.cloudfront.net/ID/ID.mp4
 */
export const uploadVideo = async (blobFile: Blob): Promise<string | null> => {
    console.log('blobFile', blobFile)
    //generate an id
    const videoId = shortuuid.generate();
    const key = videoId + "/" + videoId + ".mp4";
    try {
        const file: File | null = blobToFile(blobFile, videoId + ".mp4");
        if (file) {
            // Use S3 ManagedUpload class as it supports multipart uploads
            var upload = new AWS.S3.ManagedUpload({
                params: {
                    Bucket: bucketName,
                    Key: key,
                    Body: file,
                }
            });

            await upload.promise();

            return videoId;
        }
    } catch (error) {
        console.error("An error ocurred uploading file to s3 with id:" + videoId);
    }

    return null;
}